/* eslint-disable sort-keys */

import { Icon } from '@clientbase/clientbase-library'
import { Box, Tooltip } from '@mui/material'

import { ButtonRounded } from 'components/button'
import Can from 'components/Can'
import Status, { StatusKeys } from 'components/Status'
import { TableNameWrapper, TableNickname } from 'components/Table/Table.styles'

import { formatDate } from 'utils/FormatDate'
import { formatMoney } from 'utils/FormatMoney'

import { theme } from 'styles/theme'

type ConvertToRowsParams = {
  records: any
  actions: any
}

type CreateDataTableProps = {
  name: string
  due_date: string
  status: string
  amount: string
  uuid: string
  actions: any
}

export const createDataTable = ({
  uuid,
  name,
  due_date,
  status,
  amount,
  actions
}: CreateDataTableProps) => {
  return {
    uuid,
    name: (
      <TableNameWrapper>
        <TableNickname>{name}</TableNickname>
      </TableNameWrapper>
    ),
    due_date: formatDate(due_date),
    status: <Status status={status as StatusKeys} dueDate={due_date} />,
    amount: formatMoney(amount),
    actions: (
      <Can permission="billings:show">
        <Tooltip
          enterTouchDelay={0}
          arrow={true}
          placement="top"
          title="Detalhes cobrança"
        >
          <Box
            maxWidth="50px"
            zIndex={999}
            onClick={() => actions.handleOpenModal(uuid)}
          >
            <ButtonRounded variant="transparent" data-cy="open-billing">
              <Icon
                icon="settings"
                sx={{ color: theme.palette.neutral[200] }}
              />
            </ButtonRounded>
          </Box>
        </Tooltip>
      </Can>
    )
  }
}

export const convertToRows = ({ records, actions }: ConvertToRowsParams) =>
  records?.map((record: any) => {
    if (!record) return {}
    return createDataTable({
      uuid: record?.uuid,
      name: record?.customer?.name,
      due_date: record?.dueDate,
      status: record?.status,
      amount: record?.amountBilled,
      actions
    })
  })
